import SupplierView from './SupplierView';
export default SupplierView;
